import { render, staticRenderFns } from "./cflist.vue?vue&type=template&id=cd8228f4&scoped=true&"
import script from "./cflist.vue?vue&type=script&lang=js&"
export * from "./cflist.vue?vue&type=script&lang=js&"
import style0 from "./cflist.vue?vue&type=style&index=0&id=cd8228f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8228f4",
  null
  
)

export default component.exports